<template>
  <GenericPage
    title="קצת עלינו"
    subtitle="הסיפור שמאחורי RGift"
    :content="aboutContent"
    bannerImage="/images/aboutSection.jpg"
  />
</template>

<script>
import GenericPage from "../pages/GenericPage.vue";

export default {
  components: {
    GenericPage,
  },
  computed: {
    aboutContent() {
      const whatsappNum = this.$store.getters["getWhatsappNum"];
      return `
<div>
  <h2>קצת עלינו - הסיפור מאחורי RGIFT</h2>
  <p>ב-RGIFT אנחנו מתמחים בהפיכת כל רגע לחגיגה בלתי נשכחת. מבחר עצום של מוצרי נוי, מוצרים לימי הולדת, אריזות ושקיות - הכול במקום אחד, עם שילוב של איכות, עיצוב ויחס אישי שמותאם בדיוק לצרכים שלכם.</p>
  <p>מאחורי האתר עומדת<b> ארגיפט 2022 יבוא ושיווק בע"מ </b>— חברה שמייבאת ומשווקת את המוצרים ישירות, בלי מתווכים מיותרים, כדי לשמור על מחיר הוגן ובקרת איכות צמודה על כל פריט שמגיע אליכם.</p>

  <h2>מה תמצאו אצלנו</h2>
  <ul class="mb-4">
    <li><a href="/decorative">מוצרי נוי</a> — אגרטלים, פרחים, עצים ועציצים מעוצבים, מגשים, נרות דקורטיביים, סלסלאות ואביזרים לבית ולעסק.</li>
    <li><a href="/packaging">אריזות</a> — שקיות נייר, שקיות צלופן ואורגנזה, סרטי סאטן וקשירה, ומגוון מוצרי אריזה נוספים שהופכים כל מתנה לבלתי נשכחת.</li>
    <li><a href="/birthdays">ימי הולדת</a> — נרות מספר, נרות מעוצבים, באנרים ואביזרים לצד העוגה, לחגיגה מושלמת.</li>
  </ul>

  <h2>לקוח עסקי? הגעתם למקום הנכון</h2>
  <p>אם אתם עסק שמחפש פתרונות מרהיבים ומיוחדים - RGIFT מציעה מבחר עצום של מוצרים באיכות גבוהה ובמגוון רחב של סגנונות. אנחנו מתחייבים למשלוח מהיר ומדויק וליחס אישי, כדי שהמוצרים יגיעו אליכם בדיוק בזמן.</p>

  <h2>מארגנים אירוע גדול?</h2>
  <p>מתכננים חגיגה בלתי נשכחת? אצלנו תמצאו את כל מה שצריך במקום אחד — מסטייל ייחודי למתנות ועד הפרטים הקטנים שמשדרגים כל אירוע. אפשר לבצע קניות גדולות בקלות ובנוחות, עם שירות מהיר שמתאים בדיוק להיקף ההזמנה שלכם.</p>

  <h2>למה לקוחות בוחרים ב-RGIFT?</h2>
  <ul>
    <li>שירות מהיר ובזמן, מותאם במיוחד לצרכים העסקיים שלכם</li>
    <li>צוות שמבין את צרכי העסק ונותן מענה אישי</li>
    <li>מגוון רחב שמתעדכן לפי עונה ומגמות</li>
    <li>פתרונות גמישים לכל היקף הזמנה - מיחידות בודדות ועד הזמנות סיטונאיות</li>
    <li>יבוא ושיווק ישיר, בלי מתווכים - מה שמאפשר לנו לשמור על מחיר הוגן ובקרת איכות צמודה</li>
  </ul>

  <h2>רוצים להתייעץ איתנו?</h2>
  <p>צוות RGIFT זמין בשבילכם: <a href="tel:0524661378">052-4661378</a> / <a href="tel:0506665638">050-6665638</a>, במייל <a href="mailto:rgift494@gmail.com">rgift494@gmail.com</a>, או ב-<a href="https://wa.me/${whatsappNum}" target="_blank" rel="noopener">וואטסאפ</a>. נשמח לעזור לכם למצוא בדיוק את מה שאתם צריכים.</p>
</div>
      `;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .content-wrapper {
  li::marker {
    content: none !important;
  }

  ul {
    list-style: none;
  }

  li {
    position: relative;
    padding-right: 18px;

    &::before {
      // content: ".";
      position: absolute;
      right: 4px;
      top: 0;
      font-size: 1.2em;
    }
  }
}
</style>
